__turbopack_context__.v({
  "section": "page-module-scss-module__sJ33jG__section",
  "wrapper": "page-module-scss-module__sJ33jG__wrapper",
});
